// extracted by mini-css-extract-plugin
export default {"cls1":"buttonStyles-cls1___95cb22b05227b15c265","cls2":"buttonStyles-cls2__fef8a184c28591b72df5 buttonStyles-cls1___95cb22b05227b15c265"};